import { Link } from "react-router-dom";

/* SAMPLE DATA */
import navMenu from "../../data/navigation";

const Sidebar = () => {
  var pathname = window.location.pathname;

  return (
    <section className="h-screen w-sidebar bg-[#000000] transition-all duration-300 ease-linear px-2">
      {/* HEADER */}
      <div className="py-5 border-b border-white border-opacity-20">
        <img
          src={`https://storage.googleapis.com/cdn-roundtechsquare/p5-graphics/p5-logo-white.png`}
          className="w-auto h-12 object-contain "
          alt="P5 Graphics and Displays"
        />
      </div>

      {/* NAVIGATION OPTIONS */}
      <div className="flex flex-col justify-between mt-5">
        {navMenu.map((nav) => (
          <Link
            to={nav.link}
            key={nav.id}
            className="w-full group flex items-center gap-3 first:mt-5 mt-8"
          >
            <nav.icon
              className={`w-5 h-5 text-sidebarText ${pathname === nav.link &&
                "text-white"} group-hover:text-white transition-all duration-300 ease-in-out`}
            />
            <div>
              <p
                className={`text-base font-ibm-semibold text-sidebarText ${pathname ===
                  nav.link &&
                  "text-white"} group-hover:text-white leading-none transition-all duration-300 ease-in-out`}
              >
                {nav.name}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default Sidebar;
